import { defineMessages } from 'react-intl';

const messages: {
	mySpacesListLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mySpacesSectionHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dailyBriefChatName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkedResourcesSection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatGreeting: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	mySpacesListLabel: {
		id: 'rovo-for-you.my-spaces-list.label',
		defaultMessage: 'Spaces',
		description: 'Accessible label for the spaces list container in the For You tab',
	},
	mySpacesSectionHeading: {
		id: 'rovo-for-you.my-spaces-list.section-heading',
		defaultMessage: 'Spaces',
		description: 'Section heading for the spaces list in the For You tab',
	},
	dailyBriefChatName: {
		id: 'rovo-for-you.my-projects-list.daily-brief-chat-name',
		defaultMessage: 'Daily Brief: {spaceName}',
		description:
			'Name given to a Rovo Chat conversation started from the Daily Brief button on a project card',
	},
	linkedResourcesSection: {
		id: 'rovo-for-you.my-projects-list.linked-resources-section',
		defaultMessage:
			' The following linked resources are associated with this space and should be prioritised as primary sources: {links}.',
		description:
			'Sentence injected into the daily brief prompt listing the linked resources for a space. {links} is a comma-separated list of link names and URLs.',
	},
	chatGreeting: {
		id: 'rovo-for-you.my-projects-list.chat-greeting',
		defaultMessage: 'Chat about anything in this space',
		description:
			'Greeting message shown as the first agent message when opening a new chat from a space card',
	},
});

export default messages;
